import { Injectable } from '@angular/core';
import { IdentityPayload, IdentityProvider } from '../lib/identity.interfaces';
import { isValidBeRrn, sanitizeBeRrn } from './be-rrn.validator';

@Injectable()
export class RijksregisterService implements IdentityProvider<string> {
  manages(token: string): boolean {
    return token === 'be:rrn';
  }

  validate(token: string, value: unknown): void {
    if (!isValidBeRrn(value)) {
      throw new Error('Invalid rijksregisternumber');
    }
  }

  transformValueToPayload(
    token: string,
    value: unknown,
  ): IdentityPayload<string> {
    return { type: 'be:rrn', payload: sanitizeBeRrn(value) };
  }

  getValueFromIdentities(identities: IdentityPayload[], token: string): any {
    return identities.find((id) => id.type === 'be:rrn')?.payload ?? '';
  }

  modifyIdentity(identities: IdentityPayload[], token: string, value: unknown) {
    const payload = this.transformValueToPayload(token, value);
    const idx = identities.findIndex((identity) => identity.type === 'be:rrn');
    if (idx === -1) {
      identities.push(payload);
    } else {
      identities[idx] = payload;
    }
  }
}
